import { render, staticRenderFns } from "./IconCollapse.vue?vue&type=template&id=643f763e&"
import script from "./IconCollapse.vue?vue&type=script&lang=ts&"
export * from "./IconCollapse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports